import React from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import QuantitySelector from "../product/QuantitySelector";
import { useStore } from "../../context/StoreProvider";
import { formatPrice } from "../../lib/utils";

const CartItem = ({ item, compact = false }) => {
  const { updateQuantity, removeFromCart } = useStore();
  return (
    <div className="flex gap-4 py-4" data-testid={`cart-item-${item.lineId}`}>
      <Link to={`/product/${item.slug}`} className="shrink-0">
        <div className={`${compact ? "h-24 w-20" : "h-32 w-24"} overflow-hidden bg-cream`}>
          <img src={item.image} alt={item.name} className="h-full w-full object-cover" />
        </div>
      </Link>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-start justify-between gap-2">
          <Link to={`/product/${item.slug}`} className="min-w-0">
            <h4 className="truncate text-sm font-medium">{item.name}</h4>
          </Link>
          <button
            onClick={() => removeFromCart(item.lineId)}
            aria-label="Remove item"
            data-testid={`cart-remove-${item.lineId}`}
            className="text-ink/40 transition-colors hover:text-ink"
          >
            <X size={18} />
          </button>
        </div>
        <p className="mt-1 font-mono text-[11px] uppercase tracking-wider text-ink/50">
          {item.size} · {item.color}
        </p>
        <div className="mt-auto flex items-center justify-between pt-3">
          <QuantitySelector
            value={item.quantity}
            onChange={(q) => updateQuantity(item.lineId, q)}
            size="sm"
          />
          <span className="font-mono text-sm">
            {formatPrice(item.price * item.quantity)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
